/**
 * Deep merges two i18next resource objects.
 *
 * @param {object} source1 - The first resource object.
 * @param {object} source2 - The second resource object, whose translations will be merged into the first.
 * @returns {object} The deeply merged resource object.
 */
export const mergeTranslations = (source1, source2) => {
  // Create a deep copy of the first source to avoid modifying the original object
  const merged = JSON.parse(JSON.stringify(source1));

  for (const langKey in source2) {
    // Check if the language exists in the source and has a translation object
    if (Object.prototype.hasOwnProperty.call(source2, langKey) && source2[langKey].translation) {
      // If the language doesn't exist in the merged object, initialize it
      if (!merged[langKey]) {
        merged[langKey] = { translation: {} };
      } else if (!merged[langKey].translation) {
        merged[langKey].translation = {};
      }

      // Merge the translations for the current language
      merged[langKey].translation = {
        ...merged[langKey].translation,
        ...source2[langKey].translation,
      };
    }
  }

  return merged;
};

